"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCompleteRegistrationFragment = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _client = require("@apollo/client");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  fragment useCompleteRegistrationFragment on Store {\n    id\n    adTracks {\n      googleAdwordsConfig\n      googleAdwordsSignUp\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

// definition
var useCompleteRegistrationFragment = (0, _client.gql)(_templateObject());
exports.useCompleteRegistrationFragment = useCompleteRegistrationFragment;